export const BUILD_VERSION = '1791873948';
